export default "__VITE_ASSET__D7jkbGix__"